import { ComponentCO2Link } from '@acies/domain';

interface ISearchCO2LinkResult {
	items: ComponentCO2Link[];
	total: number;
}

export default class SearchCO2LinkResult implements ISearchCO2LinkResult {
	public items: ComponentCO2Link[];
	public total: number;
	public constructor({ items, total }: ISearchCO2LinkResult) {
		this.items = items;
		this.total = total;
	}
}
